export const LOAD_ALLOWED_PHYSIO_ORIGINS_SUCCESS = "LOAD_ALLOWED_PHYSIO_ORIGINS_SUCCESS";

export const LOAD_ALLOWED_PHYSIO_ORIGINS = "LOAD_ALLOWED_PHYSIO_ORIGINS";
